import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import PythonLogo from '../components/shared/logos/PythonLogo.vue'
import ExcelLogo from '../components/shared/logos/ExcelLogo.vue'

Vue.use(Vuetify)

const vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi',
        values: {
            pythonLogo: {
                component: PythonLogo,
            },
            excelLogo: {
                component: ExcelLogo,
            },
        },
    },
    theme: {
        dark: false,
        themes: {
            options: {
                customProperties: true,
            },
            light: {
                primary: '#E61E28',
                secondary: '#1C1C1C',
                accent: '#E61E28',
                error: '#E61E28',
                border: '#FAFAFA',
                typography1: '#1C1C1C',
                typography2: '#E61E28',
                typography3: '#FFFFFF',
            },
            dark: {
                primary: '#1C1C1C',
                secondary: '#FFFFFF',
                accent: '#E61E28',
                error: '#E61E28',
                border: '#000000',
                typography1: '#FAFAFA',
                typography2: '#FAFAFA',
            },
        },
    },
})

export default vuetify
